<script>
import EChart from '../Charts/ECharts'
import {TEXT_FONT_FAMILY} from './FactorCharts/chartStyle'

export default {
  name: 'OcEcPm25',
  extends: EChart,
  props: {
    query: {
      required: true,
      type: Object
    },
    factorMap: {
      required: true,
      type: Object
    },
    data: {
      required: true,
      type: Object
    },
    selectedNames: {
      required: true,
      type: Array
    }
  },
  methods: {
    render () {
      let {query, factorMap, data} = this
      let beginTS = new Date(query.beginTime).getTime()
      let endTS = new Date(query.endTime).getTime()
      let timeInterval = query.dataType * 60000
      let dataTimes = []

      for (let i = beginTS; i <= endTS; i += timeInterval) {
        dataTimes.push(new Date(i).format())
      }

      let dataTimesLen = dataTimes.length
      let series = Object.values(data.data.reduce((map, data) => {
        let {factorId} = data
        let seriesData = map[factorId]

        if (seriesData) {
          let index = (new Date(data.dataTime).getTime() - beginTS) / timeInterval
          let {value} = data

          seriesData.data[index] = value
        }

        return map
      }, query.factorIds.reduce((map, factorId) => {
        let factor = factorMap[factorId]
        let series = map[factorId] = {
          id: factorId,
          name: factor.name,
          data: new Array(dataTimesLen).fill(null),
          showSymbol: false
        }

        if (factorId === '1008') {
          series.type = 'line'
        } else {
          series.type = 'bar'
          series.stack = 'ocec'
        }

        return map
      }, {})))

      let chartOpt = {
        title: {
          text: this.data.siteName,
          left: 'center',
          textStyle: {
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          top: -6,
          right: 0
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true
        },
        legend: {
          top: 27,
          left: 'center',
          type: 'scroll',
          width: '80%',
          selected: this.getSelected()
        },
        grid: {
          top: 75,
          right: 20,
          bottom: 50,
          left: 20,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: dataTimes,
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          name: 'μg/m3',
          axisLine: {
            show: true
          },
          axisTick: {
            show: true
          }
        },
        dataZoom: [{
          type: 'inside',
          start: dataTimes.length <= 72 ? 0 : ((dataTimes.length - 72) / dataTimes.length * 100).toFixed(0),
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: dataTimes.length <= 72 ? 0 : ((dataTimes.length - 72) / dataTimes.length * 100).toFixed(0),
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        series: series
      }

      this.setOpt(chartOpt)
    },
    getSelected () {
      let factorIdMap = this.selectedNames.reduce((map, name) => {
        map[name] = true
        return map
      }, {})

      let {factorMap} = this

      this.query.factorIds.reduce((map, factorId) => {
        let factor = factorMap[factorId]

        if (factor) {
          let {name} = factor

          if (!map[name]) {
            map[name] = false
          }
        }

        return map
      }, factorIdMap)

      return factorIdMap
    },
    onLegendSelectChanged (param) {
      this.selected = Object.freeze(JSON.parse(JSON.stringify(param.selected)))
      this.$emit('update:selectedNames', Object.entries(this.selected).filter(selected => selected[1]).map(selected => selected[0]))
    },
    afterInit () {
      this.initialized = true
      this.myChart.on('legendselectchanged', this.onLegendSelectChanged)
      this.render()
    },
    destroy () {
      this.myChart.off('legendselectchanged', this.onLegendSelectChanged)
    }
  },
  watch: {
    data () {
      if (this.initialized) {
        this.render()
      }
    },
    selectedNames (selectedNames, old) {
      if (selectedNames !== old) {
        return
      }

      let chartOpt = this.getOpt()

      if (!chartOpt) {
        return
      }

      this.setOpt({
        legend: {
          selected: this.getSelected()
        }
      }, true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Data/OcEcPm25.vue